import _ from 'lodash';
import user from '../../api/user';
import * as types from '../mutation-types';

const state = {
  owners: [
    {
      id: null,
      full_name: null,
      roles: []
    }
  ]
};

const getters = {
  OwnersList: state => state.owners,
  OwnerName: state => id => {
    if (_.isNull(id)) {
      return null;
    }

    let index = _.findIndex(state.owners, { id });
    if (index < 0) {
      return null;
    }
    return state.owners[index].full_name;
  }
};

const actions = {
  getOwnersList({ commit, state }) {
    if (state.owners.length > 1) {
      return Promise.resolve();
    }
    return user.getUsersByRole({ role: 'Owner' }).then(response => commit(types.SET_OWNERS, response.data));
  }
};

const mutations = {
  [types.SET_OWNERS](state, response) {
    state.owners = response;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
